import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';


import Card from '../components/Card';
import SectionsRow from '../components/SectionsRow';

import InputComponent from '../components/InputComponent';
import DropDownList from '../components/DropDownList';
import ResultsContainer from '../components/Results';
import FlowRateComponent from '../components/FlowrateComponent';


import ValvesFittingsComponent from './ValvesFittingsComponent';
import CalculationType from './CalculationType';

import Insulation from '../components/insulation/Insulation';
import { pdfCreateRequest } from '../modules/app';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';


import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import ductIcon from '../assets/images/03_Paroc_calculus_Icons.png';
import ductSelectedIcon from '../assets/images/03_Paroc_calculus_Icons.png';

import duct2Icon from '../assets/images/04_Paroc_calculus_Icons.png';
import duct2SelectedIcon from '../assets/images/04_Paroc_calculus_Icons.png';

// Dimension icons
import planeDimensions from '../assets/images/plane-dimensions@2x.png';
import circPlaneDimensions from '../assets/images/circular-plane.png';
import pipeDimensions from '../assets/images/pipe-dimensions@2x.png';
import cDuctDimensions from '../assets/images/c-duct-dimensions@2x.png';
import rDuctDimensions from '../assets/images/r-duct-dimensions@2x.png';
import vCTankDimensions from '../assets/images/v-c-tank-dimensions@2x.png';
import hCTankDimensions from '../assets/images/h-c-tank-dimensions@2x.png';
import rTankDimensions from '../assets/images/r-tank-dimensions@2x.png';

import { openSetting } from '../modules/app';

import { patchCalculation, patchCalculationSection, CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, CALCULATION_TOP_LAYERS, CALCULATION_SIDE_LAYERS, CALCULATION_FLOWRATE_TYPE_KG_TO_S, CALCULATION_FLOWRATE_TYPE_M3_TO_H, CALCULATION_FLOWRATE_TYPE_L_TO_S, CALCULATION_FLOWRATE_TYPE_M_TO_S } from '../modules/calculation';

import { getUIText } from '../utils/index';
import { adobeClickInsulationObject} from '../utils/analytics';

const ITEM_HEIGHT = 48;

class Calculator extends Component {

  state = {
    anchorElResultsSettings: undefined,
    openResultsSettings: false,
  };

  handleResultsSettingsClick = event => {
    this.setState({ openResultsSettings: true, anchorElResultsSettings: event.currentTarget });
  };

  handleRequestResultsSettingsClose = (id) => {
    this.setState({ openResultsSettings: false });
    if(!id) {
      return;
    }
    switch (id) {
      case 'm':
        if(this.props) {
          this.props.onHeatlossUnitTypeChange('m');
        }
        break;

      case 'm2':
        if(this.props) {
          this.props.onHeatlossUnitTypeChange('m2');
        }
        break;

      default:
        break;
    }
  };

  onSuspensionInsideClick = () => {
    this.props.onSuspensionHeatlossChange(this.props.settings['Default-suspension-value']);
  };

  onSuspensionOutsideClick = () => {
    this.props.onSuspensionHeatlossChange(this.props.settings['Default-suspension-value-outdoor']);
  };

  onSupportInsideClick = () => {
    this.props.onInfluenceOnHeatlossChange(this.props.settings['Default-support-value']);
  };

  onSupportOutsideClick = () => {
    this.props.onInfluenceOnHeatlossChange(this.props.settings['Default-support-value-outdoor']);
  };

  render() {
    const {
      project,
      settings,
      user,
      app,
      translations,
      adapters,

      onDirectionChange,
      onShapeChange,
      onPositionChange,
      onTankBaseChange,
      onConcreteThicknessChange,

      onThicknessChange,
      onTemperatureChange,
      onHeightChange,
      onWidthChange,
      onMaterialChange,
      onContentChange,

      onCalculateEnergyConsumptionChange,
      onCalculateTemperatureChange,
      onCalculateSolarRadiation,
      onCalculateFreezingChange,
      onCalculateEndTempretureChange,
      onValvesAndFittingsChange,

      onOuterDiameterChange,
      onLengthChange,
      onFreezingPercentageChange,
      onFinalTemperatureChange,

      onEnvironmentTypeChange,
      onEnvironmentAmbientTemperatureChange,
      onEnvironmentAmbientAirVelocityChange,
      onEnvironmentHumidityChange,
      onEnvironmentSolarRadiationChange,

      onEnergyTypeChange,
      onEnergyOperationTimeChange,
      onEnergyPriceChange,

      onCladdingChange,
      onEmissivityChange,
      onSupportOfCladdingChange,
      onInfluenceOnHeatlossChange,
      onSpacersPerMChange,
      onMechanicalFastenerChange,
      onMechanicalInfluenceChange,
      onMechanicalPerMChange,
      onSuspensionChange,
      onSuspensionHeatlossChange,

      onHeatlossUnitTypeChange,

      onInsulationLayerChange,
      onInsulationLayerPositionChange,
      onSectionIndexChange,
      onFlowRateChange,
      onFlowRateTypeChange,
      onNoInsulationChange,
      onDuctTypeChange,
      createPDF,
      openSetting,
      onMaterialStandardChange,
      onKlasseChange,
   } = this.props;

   const {
     calculations,
     calculationIndex,
   } = project;

   const {
     calculateTemperatureChange,
     calculateEndTemperature,
     calculateSolarRadiation,
     flowRateType,

     sectionIndex,
     sections,

     calculateEnergyConsumption,
     energyType,
     energyOperationTime,
     energyPrice,

     results,
    } = calculations ? calculations[calculationIndex] : {};

    const {
      thickness,
      type,
      width,
      height,
      material,
      content,

      direction,
      shape,
      position,
      tankBase,
      concreteThickness,

      flowRate,
      klasse,
      noInsulation,
      materialStandard,

      calculateFreezing,
      calculateAdapters,

      environmentType,
      environmentTemperature,
      environmentAirVelocity,
      environmentHumidity,
      environmentSolarRadiation,

      outerDiameter,
      length,
      freezingPercentage,
      finalTemperature,
      temperature,
      cladding,
      emissivity,
      supportOfCladdingPossible,
      supportOfCladding,
      influenceOnHeatloss,
      spacersPerM,
      mechanicalFastener,
      mechanicalInfluence,
      mechanicalPerM,
      suspensionOfTarget,
      suspensionInfluence,
      heatlossUnitType,
      selectedLayers, // top, side, bottom
      insulationLayers,
      topInsulationLayers,
      sideInsulationLayers,
      bottomInsulationLayers,

    } = sections ? sections[sectionIndex] : {};

    let calculationInputs;
    let ductTypeCard;
    let definitionInputs;
    let measurementsInputs;
    let materialInputs;
    let contentInputs;
    let energyInputs;
    let spacerInputs;
    let sectionsContainer;
    let getMoreLink;

    // Materials standards
    const materialStandards = this.props.materialstandards;
    let materialStandardsList;
    let selectedMaterialStandard;
    if(materialStandards) {
      materialStandardsList = materialStandards.data.filter( item => {
        if(item['target-type'].toLowerCase().replace(' ', '-') === type && item.material === material) {
          return true;
        }
        return false;
      });

      if(materialStandardsList && materialStandardsList.length) {
        materialStandardsList = materialStandardsList.map( item => {
          if(item.Nid === materialStandard) {
            selectedMaterialStandard = item;
          }
          return {name: item.name, id: item.Nid};
        });

        materialStandardsList.push({
          name: getUIText('GENERAL-CUSTOM', app.language, translations),
          id: -1
        });
      }
    }

    // Materials
    //
    const { materials } = this.props;
    let materialsList;
    if(materials) {
      materialsList = materials.data.map( item => {
        if(item.hasOwnProperty('custom') && item.custom) {
          return {name: item.name, id: item.Nid, custom: true};
        } else if(item[app.language] === false) {
          return {name: item.English, id: item.Nid};
        }
        return {name: item[app.language], id: item.Nid};
      });

      if(user.username) {
        materialsList.push({
          name: getUIText('CREATE_CUSTOM', app.language, translations),
          id: -3,
          custom: true
        });
      }
    }

    // Content
    //
    const { mediums } = this.props;
    // list creating moved to under the object type definitions

    const flowRateComponent = (<FlowRateComponent data={[
        {id: CALCULATION_FLOWRATE_TYPE_KG_TO_S, name: getUIText('CONTENT-MASS_FLOW', app.language, translations) + ' (kg/s)'},
        {id: CALCULATION_FLOWRATE_TYPE_M3_TO_H, name: getUIText('CONTENT-VOLUME_FLOW', app.language, translations) + ' (m³/h)'},
        {id: CALCULATION_FLOWRATE_TYPE_L_TO_S, name: getUIText('CONTENT-VOLUME_FLOW', app.language, translations) + ' (l/s)'},
        {id: CALCULATION_FLOWRATE_TYPE_M_TO_S, name: getUIText('CONTENT-FLOW_VELOCITY', app.language, translations) + ' (m/s)'}, ]}
        min={0.1}
        selectedItem={flowRateType}
        flowRate={flowRate}
        app={app} translations={translations}
        onTypeChange={(value) => onFlowRateTypeChange(value)}
        onInputChange={(value) => onFlowRateChange(value)} />);

    const calculateHeatlossCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked
            disabled
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-CALCULATE_HEATLOSS', app.language, translations)}
        disabled
      />);

    const calculateEnergyCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateEnergyConsumption}
            onChange={(event, value) => onCalculateEnergyConsumptionChange(value)}
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-ENERGY_COMSUMPTION', app.language, translations)}
      />);

    const calculateTemperatureCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateTemperatureChange}
            onChange={(event, value) => onCalculateTemperatureChange(value)}
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-TEMPERATURE_CHANGE', app.language, translations)}
        disabled={( (sections && sections.length > 1) || calculateFreezing || calculateEndTemperature || !length || (type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT)) ? true : false}
      />);

    const calculateSolarRadiationCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateSolarRadiation}
            onChange={(event, value) => onCalculateSolarRadiation(value)}
          />
        }
        className="checkBoxContainer"
        label={'Calculate solar radiation'}
        // label={getUIText("CALCULATION-SOLAR_RADIATION", app.language, translations)}
      />);


    const calculateFreezingCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateFreezing}
            onChange={(event, value) => onCalculateFreezingChange(value)}
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-FREEZING', app.language, translations)}
        disabled={calculateTemperatureChange}
      />);


    const calculateEndTemperatureCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateEndTemperature}
            onChange={(event, value) => onCalculateEndTempretureChange(value)}
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-CALCULATE_TIME_TO_FINAL_TEMP', app.language, translations)}
        disabled={calculateTemperatureChange}
      />);

    const calculateTimeToFinalTemperatureCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateEndTemperature}
            onChange={(event, value) => onCalculateEndTempretureChange(value)}
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-CALCULATE_TIME_TO_FINAL_TEMP', app.language, translations)}
      />);

    const valvesAndFittingsCheckBoxComponent = (<FormControlLabel
        control={
          <Checkbox
            checked={calculateAdapters}
            onChange={(event, value) => onValvesAndFittingsChange(value)}
          />
        }
        className="checkBoxContainer"
        label={getUIText('CALCULATION-ADD_VALVES_AND_FITTINGS', app.language, translations)}
      />);

    const mechanicalFastenersInputs = [
        {name: getUIText('MECHANICAL_FASTENER_1', app.language, translations), id: '0.0007'},
        {name: getUIText('MECHANICAL_FASTENER_2', app.language, translations), id: '0.0005'},
      ];


    if(type === CALCULATION_TYPE_PLANE) {
      getMoreLink = getUIText('GENERAL-FLATSURFACE_GET-MORE-INFO_LINK', app.language, translations);

      // Calculations
      calculationInputs = (<Card title={getUIText('CALCULATION_CALCULATIONS-TITLE', app.language, translations)} className="card-calculations" iconClass="fa fa-check-square-o">
          <FormGroup>
            {calculateHeatlossCheckBoxComponent}
            {calculateEnergyCheckBoxComponent}
            {/* {calculateSolarRadiationCheckBoxComponent} */}
           </FormGroup>
        </Card>);

      // Definitions
      definitionInputs = (<Grid item xs={12} sm={6} md={4}>
        <Paper className="paper animated fadeIn">
          <Card title={getUIText('GENERAL_DEFINITIONS', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
            <Grid container>
              <Grid item xs={12}>
                <DropDownList
                      data={[{name: getUIText('TARGET_VERTICAL', app.language, translations), id: 'vert'}, {name: getUIText('TARGET_HORIZONTAL', app.language, translations), id: 'hor'}]}
                      selectedItem={direction}
                      label={getUIText('GENERAL_ORIENTATION', app.language, translations)}
                      onChange={(value) => onDirectionChange(value)} />
                <DropDownList
                      data={[{name: getUIText('TARGET_QUADRILATERAL', app.language, translations), id: 'square'}, {name: getUIText('TARGET_CIRCULAR', app.language, translations), id: 'round'}]}
                      selectedItem={shape}
                      label={getUIText('GENERAL_SHAPE', app.language, translations)}
                      onChange={(value) => onShapeChange(value)} />
                { direction === 'hor' &&
                  <DropDownList
                        data={[{name: getUIText('TARGET_TOP_PART', app.language, translations), id: 'top'}, {name: getUIText('TARGET_BOTTOM_PART', app.language, translations), id: 'bottom'}]}
                        selectedItem={position}
                        label={getUIText('GENERAL_LOCATION', app.language, translations)}
                        onChange={(value) => onPositionChange(value)} />
                }
              </Grid>
            </Grid>
          </Card>
        </Paper>
      </Grid>);

      spacerInputs = [
        {name: getUIText('SPACER_1', app.language, translations), id: '0.0035'},
        {name: getUIText('SPACER_2', app.language, translations), id: '0.006'},
        {name: getUIText('SPACER_3', app.language, translations), id: '0.0085'},
      ];

      // Measurements
      measurementsInputs = (<Grid item xs={12} sm={6} md={4}>
        <Paper className="paper animated fadeIn">
          <Card title={getUIText('CALCULATION_MEASUREMENTS-TITLE', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
            <Grid container>
              <Grid item xs={7}>
                {shape !== 'round'
                  ? <InputComponent
                      app={app} translations={translations}
                      value={height}
                      label={getUIText('FLAT_SURFACE-HEIGHT', app.language, translations)}
                      unit="m" onChange={(value) => onHeightChange(value)}
                      min={0.1}
                      />
                  : <InputComponent
                      app={app} translations={translations}
                      value={height}
                      label={getUIText('GENERAL-OUTER_DIAMETER', app.language, translations)}
                      unit="m" onChange={(value) => onHeightChange(value)}
                      min={0.1}
                      />
                }
                {shape !== 'round' &&
                  <InputComponent
                    app={app} translations={translations}
                    value={width}
                    label={getUIText('FLAT_SURFACE-WIDTH', app.language, translations)}
                    unit="m"
                    onChange={(value) => onWidthChange(value)}
                    min={0.1}
                    />
                }
              </Grid>
              <Grid item xs={5}>
                {shape !== 'round'
                  ? <img className="img-dimensions" src={planeDimensions} />
                  : <img className="img-dimensions" src={circPlaneDimensions} />
                }
              </Grid>
            </Grid>
          </Card>
        </Paper>
      </Grid>);

      // Material
      materialInputs = (<Card title={getUIText('PDF-MATERIAL', app.language, translations)} className="card-material" iconClass="fa fa-cube">
          <DropDownList
            data={materialsList}
            selectedItem={material}
            openSetting={() => openSetting(2)}
            label={getUIText('GENERAL-SELECT_MATERIAL', app.language, translations)}
            onChange={(value) => onMaterialChange(value)} />
          <InputComponent
            app={app} translations={translations}
            value={thickness}
            label={getUIText('GENERAL-THICKNESS', app.language, translations)}
            unit="mm"
            min={0.1}
            type="number"
            onChange={(value) => onThicknessChange(value)} />
        </Card>);

      // Content
      contentInputs = (<Card title={getUIText('CONTENT-TITLE', app.language, translations)} className="card-content" contentIc>
        <InputComponent
          app={app} translations={translations}
          value={temperature}
          label={getUIText('CONTENT-TEMPERATURE', app.language, translations)}
          unit="°C"
          onChange={(value) => onTemperatureChange(value)}
          />
      </Card>);
    } else if(type === CALCULATION_TYPE_PIPE) {
      let mediumsList;
      if(mediums) {
        mediumsList = mediums.data.map( item => {
          if(item.hasOwnProperty('custom') && item.custom) {
            return {name: item.name, id: item.Nid, custom: true};
          } else if(item[app.language] === false) {
            return {name: item.English, id: item.Nid};
          }
          return {name: item[app.language], id: item.Nid};
        });

        // TODO: only in registered user
        if(user.username) {
          mediumsList.push({
            name: getUIText('CREATE_CUSTOM', app.language, translations),
            id: -3,
            custom: true
          });
        }
      }

      getMoreLink = getUIText('GENERAL-PIPE_GET-MORE-INFO_LINK', app.language, translations);

      calculationInputs = (<Card title={getUIText('CALCULATION_CALCULATIONS-TITLE', app.language, translations)} className="card-calculations" iconClass="fa fa-check-square-o">
        <FormGroup>
          {calculateHeatlossCheckBoxComponent}
          {calculateTemperatureCheckBoxComponent}
          {/* {calculateSolarRadiationCheckBoxComponent} */}
          {calculateFreezingCheckBoxComponent}
          {calculateEnergyCheckBoxComponent}
          {calculateEndTemperatureCheckBoxComponent}
          {valvesAndFittingsCheckBoxComponent}

         </FormGroup>
      </Card>);

      // Definitions
      definitionInputs = (<Grid item xs={12} sm={6} md={4}>
        <Paper className="paper animated fadeIn">
          <Card title={getUIText('GENERAL_DEFINITIONS', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
            <Grid container>
              <Grid item xs={12}>
                <DropDownList
                      data={[{name: getUIText('TARGET_VERTICAL', app.language, translations), id: 'vert'}, {name: getUIText('TARGET_HORIZONTAL', app.language, translations), id: 'hor'}]}
                      selectedItem={direction}
                      label={getUIText('GENERAL_ORIENTATION', app.language, translations)}
                      onChange={(value) => onDirectionChange(value)} />
              </Grid>
            </Grid>
          </Card>
        </Paper>
      </Grid>);
      spacerInputs = [
        {name: getUIText('SPACER_4', app.language, translations), id: '0.01'},
        {name: getUIText('SPACER_5', app.language, translations), id: '0.004'},
        {name: getUIText('SPACER_6', app.language, translations), id: '0.003'},
      ];

      // Measurements
      measurementsInputs = (<Grid item xs={12} sm={6} md={4}>
        <Paper className="paper">
          <Card title={getUIText('CALCULATION_MEASUREMENTS-TITLE', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
            <Grid container>
              { materialStandardsList && materialStandardsList.length ?
                <Grid item xs={12}>
                  <DropDownList style={{marginBottom: '8px'}}
                    data={materialStandardsList}
                    selectedItem={materialStandard}
                    label={getUIText('GENERAL-SELECT_STANDARD_DIMENSION', app.language, translations)}
                    onChange={(value) => onMaterialStandardChange(value)} />
                </Grid> : null }

              <Grid item xs={6}>
                {/* { (calculateTemperatureChange || calculateEnergyConsumption) ? <InputComponent app={app} translations={translations} className="animated fadeIn" value={length} label={getUIText("PIPE-LEGNTH", app.language, translations)} unit="m" min={0.1} onChange={(value) => onLengthChange(value)} /> : null } */}
                <InputComponent app={app} translations={translations} className="animated fadeIn" value={length} label={getUIText('PIPE-LEGNTH', app.language, translations)} unit="m" min={0.1} onChange={(value) => onLengthChange(value)} />
                <InputComponent
                  app={app} translations={translations}
                  value={outerDiameter}
                  label={getUIText('GENERAL-OUTER_DIAMETER', app.language, translations)}
                  unit="mm"
                  min={0.2}
                  max={settings ? settings['Diameter-pipe'] : 2000}
                  onChange={(value) => onOuterDiameterChange(value)} />
              </Grid>
              <Grid item xs={6}>
                <img className="img-dimensions" src={pipeDimensions} />
              </Grid>
            </Grid>
          </Card>
        </Paper>
      </Grid>);

      // onChange={(value) => onEnvironmentAmbientTemperatureChange(value, -1)}

      // Material
      materialInputs = (<Card title={getUIText('PDF-MATERIAL', app.language, translations)} className="card-material" iconClass="fa fa-cube">
          <DropDownList
            data={materialsList}
            selectedItem={material}
            openSetting={() => openSetting(2)}
            label={getUIText('GENERAL-SELECT_MATERIAL', app.language, translations)}
            onChange={(value) => onMaterialChange(value)}/>
          <InputComponent
            app={app} translations={translations}
            value={thickness}
            label={getUIText('GENERAL-THICKNESS', app.language, translations)}
            unit="mm"
            thicknessAlert={outerDiameter <= (thickness * 2)}
            onChange={(value) => onThicknessChange(value)}
            min={0.1}
            />
        </Card>);

      // Content
      contentInputs = (<Card title={getUIText('CONTENT-TITLE', app.language, translations)} className="card-content" contentIc>
        {(sectionIndex > 0) ?
            <DropDownList data={mediumsList} selectedItem={content} label={getUIText('CALCULATION_SELECT-CONTENT', app.language, translations)} disabled/>
          : <DropDownList data={mediumsList} openSetting={() => openSetting(3)} selectedItem={content} label={getUIText('CALCULATION_SELECT-CONTENT', app.language, translations)} onChange={(value) => onContentChange(value)}/>}

        {(sectionIndex > 0) ?
            <InputComponent app={app} translations={translations} value={temperature} label={getUIText('CONTENT-TEMPERATURE', app.language, translations)} unit="°C" onChange={(value) => onTemperatureChange(value)} disabled />
          : <InputComponent app={app} translations={translations} value={temperature} label={getUIText('CONTENT-TEMPERATURE', app.language, translations)} unit="°C" onChange={(value) => onTemperatureChange(value)} />}

        { calculateFreezing ? <InputComponent app={app} translations={translations} className="animated fadeIn" value={freezingPercentage} label={getUIText('CONTENT-FREEZING_PERCENTAGE', app.language, translations)} unit="%" onChange={(value) => onFreezingPercentageChange(value)} /> : null}
        { calculateEndTemperature ? <InputComponent app={app} translations={translations} className="animated fadeIn" value={finalTemperature} label={getUIText('CONTENT-THRESHOLD_TEMPERATURE', app.language, translations)} unit="°C" onChange={(value) => onFinalTemperatureChange(value)} /> : null}
        {calculateTemperatureChange ? flowRateComponent : null}
      </Card>);
    } else if(type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      let mediumsList;
      if(mediums) {
        mediumsList = mediums.data.map( item => {
          if(item.hasOwnProperty('custom') && item.custom) {
            return {name: item.name, id: item.Nid, custom: true};
          } else if(item.hasOwnProperty('Type-of-medium') && item['Type-of-medium'] === 'Gas') {
            if(item[app.language] === false) {
              return {name: item.English, id: item.Nid};
            }
            return {name: item[app.language], id: item.Nid};
          }
        });

        // TODO: only in registered user
        if(user.username) {
          mediumsList.push({
            name: getUIText('CREATE_CUSTOM', app.language, translations),
            id: -3,
            custom: true
          });
        }
      }

      const tmpArr = [];
      for(let i = 0; i < mediumsList.length; i++) {
        if(mediumsList[i] !== undefined) {
          tmpArr.push(mediumsList[i]);
        }
      }
      mediumsList = tmpArr;

      getMoreLink = getUIText('GENERAL-CIRCULARDUCT_GET-MORE-INFO_LINK', app.language, translations);

      calculationInputs = (<Card title={getUIText('CALCULATION_CALCULATIONS-TITLE', app.language, translations)} className="card-calculations" iconClass="fa fa-check-square-o">
        <FormGroup>
          {calculateHeatlossCheckBoxComponent}
          {calculateTemperatureCheckBoxComponent}
          {/* {calculateSolarRadiationCheckBoxComponent} */}
          {calculateEnergyCheckBoxComponent}
         </FormGroup>
        </Card>);

      definitionInputs = (<Grid item xs={12} sm={6} md={4}>
      <Paper className="paper animated fadeIn">
        <Card title={getUIText('GENERAL_DEFINITIONS', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
          <Grid container>
            <Grid item xs={12}>
              <DropDownList
                    data={[{name: getUIText('TARGET_VERTICAL', app.language, translations), id: 'vert'}, {name: getUIText('TARGET_HORIZONTAL', app.language, translations), id: 'hor'}]}
                    selectedItem={direction}
                    label={getUIText('GENERAL_ORIENTATION', app.language, translations)}
                    onChange={(value) => onDirectionChange(value)} />
            </Grid>
          </Grid>
        </Card>
      </Paper>
      </Grid>);

      spacerInputs = (type === CALCULATION_TYPE_CIRCULAR_DUCT)
      ? [
        {name: getUIText('SPACER_4', app.language, translations), id: '0.01'},
        {name: getUIText('SPACER_5', app.language, translations), id: '0.004'},
        {name: getUIText('SPACER_6', app.language, translations), id: '0.003'},
      ]

      : [
        {name: getUIText('SPACER_1', app.language, translations), id: '0.0035'},
        {name: getUIText('SPACER_2', app.language, translations), id: '0.006'},
        {name: getUIText('SPACER_3', app.language, translations), id: '0.0085'},
      ];

      // Duct type
      ductTypeCard = (<Grid item xs={12} sm={6} md={4} >
        <Paper className="paper">
          <Card title={getUIText('CALCULATION-SELECT_DUCT_TYPE', app.language, translations)} className="card-calculations" iconClass="fa fa-cubes">
            <div className="tiles">
              <div className={'tile tile-col-xs-6' + ((type === CALCULATION_TYPE_CIRCULAR_DUCT) ? ' active' : '')}
                  onClick={() => { adobeClickInsulationObject('Circular Duct', getUIText('CALCULATION-CIRCULAR', app.language, translations), 'select duct type'); onDuctTypeChange(CALCULATION_TYPE_CIRCULAR_DUCT) }}>
                <div className="tile-img-container">
                  <img src={ductIcon} />
                  <img className="active" src={ductSelectedIcon} />
                </div>
                <div className="tile-label">
                  {getUIText('CALCULATION-CIRCULAR', app.language, translations)}
                </div>
              </div>
              <div className={'tile tile-col-xs-6' + (type === CALCULATION_TYPE_RECTANGULAR_DUCT ? ' active' : '')}
                  onClick={() => { adobeClickInsulationObject('Rectangular Duct', getUIText('CALCULATION-RECTANGULAR', app.language, translations), 'select duct type'); onDuctTypeChange(CALCULATION_TYPE_RECTANGULAR_DUCT)}}>
                <div className="tile-img-container">
                <img src={duct2Icon} />
                <img className="active" src={duct2SelectedIcon} />
                </div>
                <div className="tile-label">
                  {getUIText('CALCULATION-RECTANGULAR', app.language, translations)}
                </div>
              </div>
            </div>
          </Card>
        </Paper>
      </Grid>);

      // Measurements
      measurementsInputs = (<Grid item xs={12} sm={6} md={4}>
        <Paper className="paper">
          <Card title={getUIText('CALCULATION_MEASUREMENTS-TITLE', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
            <Grid container>
              { materialStandardsList && materialStandardsList.length ?
                <Grid item xs={12}>
                  <DropDownList style={{marginBottom: '8px'}}
                    data={materialStandardsList}
                    selectedItem={materialStandard}
                    label={getUIText('GENERAL-SELECT_STANDARD_DIMENSION', app.language, translations)}
                    onChange={(value) => onMaterialStandardChange(value)} />
                </Grid> : null}
              <Grid item xs={6}>
                {/* { (calculateTemperatureChange || calculateEnergyConsumption)? <InputComponent app={app} translations={translations} className="animated fadeIn" value={length} label={getUIText("CIRCULAR_DUCT-LEGNTH", app.language, translations)} unit="m" onChange={(value) => onLengthChange(value)} /> : null} */}
                <InputComponent app={app} translations={translations} className="animated fadeIn" value={(length === 0 ? '' : length)} label={getUIText('CIRCULAR_DUCT-LEGNTH', app.language, translations)} unit="m" onChange={(value) => onLengthChange(value)} min={0.1}/>
                { ( type === CALCULATION_TYPE_CIRCULAR_DUCT) ? <InputComponent app={app} translations={translations} value={outerDiameter} label={getUIText('GENERAL-OUTER_DIAMETER', app.language, translations)} unit="mm" min={0.1} onChange={(value) => onOuterDiameterChange(value)} /> : null }
                { type === CALCULATION_TYPE_RECTANGULAR_DUCT ? <InputComponent app={app} translations={translations} value={width} label={getUIText('GENERAL-WIDTH', app.language, translations)} unit="mm" min={0.1} onChange={(value) => onWidthChange(value)} /> : null }
                { type === CALCULATION_TYPE_RECTANGULAR_DUCT ? <InputComponent app={app} translations={translations} value={height} label={getUIText('GENERAL-HEIGHT', app.language, translations)} type="number" unit="mm" min={0.1} onChange={(value) => onHeightChange(value)} /> : null }
              </Grid>
              <Grid item xs={6}>
                <img className="img-dimensions" src={ (type === CALCULATION_TYPE_CIRCULAR_DUCT ) ? cDuctDimensions : rDuctDimensions } />
              </Grid>
            </Grid>
          </Card>
        </Paper>
      </Grid>);

      let thicknessAlert;
      if(type === CALCULATION_TYPE_CIRCULAR_DUCT) {
        thicknessAlert = (outerDiameter <= (thickness * 2));
      } else {
        if (width / 2 <= thickness) {
  				thicknessAlert = true;
  			}
  			if (height / 2 <= thickness) {
  				thicknessAlert = true;
  			}
      }

      // Material
      materialInputs = (<Card title={getUIText('PDF-MATERIAL', app.language, translations)} className="card-material" iconClass="fa fa-cube">
          <DropDownList
            data={materialsList}
            selectedItem={material}
            openSetting={() => openSetting(2)}
            label={getUIText('GENERAL-SELECT_MATERIAL', app.language, translations)}
            onChange={(value) => onMaterialChange(value)}/>
          <InputComponent
            app={app} translations={translations}
            value={thickness}
            label={getUIText('GENERAL-THICKNESS', app.language, translations)}
            unit="mm"
            min={0.1}
            thicknessAlert={thicknessAlert}
            onChange={(value) => onThicknessChange(value)} />
        </Card>);

      // Content
      contentInputs = (<Card title={getUIText('CONTENT-TITLE', app.language, translations)} className="card-content" contentIc>
        {(sectionIndex > 0 && calculateTemperatureChange) ?
            <DropDownList data={mediumsList} openSetting={() => openSetting(3)} customHeader={getUIText('SETTINGS-CUSTOM_MEDIUMS', app.language, translations)} selectedItem={content} label={getUIText('CALCULATION_SELECT-CONTENT', app.language, translations)} onChange={(value) => onContentChange(value)} disabled/>
          : <DropDownList data={mediumsList} openSetting={() => openSetting(3)} customHeader={getUIText('SETTINGS-CUSTOM_MEDIUMS', app.language, translations)} selectedItem={content} label={getUIText('CALCULATION_SELECT-CONTENT', app.language, translations)} onChange={(value) => onContentChange(value)}/>}
        {(sectionIndex > 0 && calculateTemperatureChange) ?
            <InputComponent app={app} translations={translations} value={temperature} label={getUIText('CONTENT-TEMPERATURE', app.language, translations)} unit="°C" onChange={(value) => onTemperatureChange(value)} disabled/>
          : <InputComponent app={app} translations={translations} value={temperature} label={getUIText('CONTENT-TEMPERATURE', app.language, translations)} unit="°C" onChange={(value) => onTemperatureChange(value)} />}
        {flowRateComponent}
      </Card>);
    } else if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      let mediumsList;
      if(mediums) {
        mediumsList = mediums.data.map( item => {
          if(item.hasOwnProperty('custom') && item.custom) {
            return {name: item.name, id: item.Nid, custom: true};
          } else if( item['Type-of-medium'] === 'Liquid' || item['Type-of-medium'] === 'Gas') {
            if(item[app.language] === false) {
              return {name: item.English, id: item.Nid};
            }
            return {name: item[app.language], id: item.Nid};
          }
        });

        // TODO: only in registered user
        if(user.username) {
          mediumsList.push({
            name: getUIText('CREATE_CUSTOM', app.language, translations),
            id: -3,
            custom: true
          });
        }
      }

      const tmpArr = [];
      for(let i = 0; i < mediumsList.length; i++) {
        if(mediumsList[i] !== undefined) {
          tmpArr.push(mediumsList[i]);
        }
      }
      mediumsList = tmpArr;

      if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK) {
        getMoreLink = getUIText('GENERAL-CIRCULARTANK_GET-MORE-INFO_LINK', app.language, translations);
      } else {
        getMoreLink = getUIText('GENERAL-RECTANGULARTANK_GET-MORE-INFO_LINK', app.language, translations);
      }

      calculationInputs = (<Card title={getUIText('CALCULATION_CALCULATIONS-TITLE', app.language, translations)} className="card-calculations" iconClass="fa fa-check-square-o">
          <FormGroup>
            {calculateHeatlossCheckBoxComponent}
            {calculateEnergyCheckBoxComponent}
            {/* {calculateSolarRadiationCheckBoxComponent} */}
            {calculateTimeToFinalTemperatureCheckBoxComponent}

          </FormGroup>
        </Card>);

      if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
        // Definitions
        definitionInputs = (<Grid item xs={12} sm={6} md={4}>
          <Paper className="paper animated fadeIn">
            <Card title={getUIText('GENERAL_DEFINITIONS', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
              <Grid container>
                <Grid item xs={12}>
                  <DropDownList
                        data={[{name: getUIText('TARGET_CONCRETE', app.language, translations), id: 'concrete'}, {name: getUIText('TARGET_GROUND', app.language, translations), id: 'ground'}, {name: getUIText('TARGET_LEGS', app.language, translations), id: 'legs'}]}
                        selectedItem={tankBase}
                        label={getUIText('GENERAL_TANK_STANDING', app.language, translations)}
                        onChange={(value) => onTankBaseChange(value)} />
                  { tankBase === 'concrete' &&
                    <InputComponent
                        app={app} translations={translations}
                        value={concreteThickness}
                        // label={getUIText("FLAT_SURFACE-HEIGHT", app.language, translations)}
                        label={getUIText('GENERAL_CONCRETE_THICKNESS', app.language, translations)}
                        unit="mm" onChange={(value) => onConcreteThicknessChange(value)}
                        min={1}
                        />
                  }

                </Grid>
              </Grid>
            </Card>
          </Paper>
        </Grid>);
      }

      spacerInputs = [
        {name: getUIText('SPACER_1', app.language, translations), id: '0.0035'},
        {name: getUIText('SPACER_2', app.language, translations), id: '0.006'},
        {name: getUIText('SPACER_3', app.language, translations), id: '0.0085'},
      ];

      // Measurements
      measurementsInputs = (<Grid item xs={12} sm={6} md={4}>
          <Paper className="paper">
            <Card title={getUIText('CALCULATION_MEASUREMENTS-TITLE', app.language, translations)} className="card-measurements" iconClass="fa fa-arrows">
              <Grid container>
                <Grid item xs={6}>
                  { type === CALCULATION_TYPE_RECTANGULAR_TANK ? <InputComponent app={app} translations={translations} value={width} label={getUIText('GENERAL-WIDTH', app.language, translations)} type="number" unit="mm" min={0.1} onChange={(value) => onWidthChange(value)} /> : null }
                  { type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK ? <InputComponent app={app} translations={translations} value={height} label={getUIText('GENERAL-HEIGHT', app.language, translations)} type="number" unit="mm" min={0.1} onChange={(value) => onHeightChange(value)} /> : null }
                  { type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK ? <InputComponent app={app} translations={translations} value={length} label={getUIText('GENERAL-LENGHT', app.language, translations)} type="number" unit="mm" min={0.1} onChange={(value) => onLengthChange(value)} /> : null }
                  { type !== CALCULATION_TYPE_RECTANGULAR_TANK ? <InputComponent app={app} translations={translations} value={outerDiameter} label={getUIText('GENERAL-OUTER_DIAMETER', app.language, translations)} type="number" unit="mm" min={0.1} onChange={(value) => onOuterDiameterChange(value)} /> : null }
                </Grid>
                <Grid item xs={6}>
                  <img className="img-dimensions" src={ type === CALCULATION_TYPE_RECTANGULAR_TANK ? rTankDimensions : ( type === CALCULATION_TYPE_VERTICAL_TANK ? vCTankDimensions : hCTankDimensions ) } />
                </Grid>
              </Grid>
            </Card>
          </Paper>
        </Grid>);

      // Material
      materialInputs = (<Card title={getUIText('PDF-MATERIAL', app.language, translations)} className="card-material" iconClass="fa fa-cube">
          <DropDownList data={materialsList} openSetting={() => openSetting(2)} customHeader={getUIText('SETTINGS-CUSTOM_MATERIAL', app.language, translations)} selectedItem={material} label={getUIText('GENERAL-SELECT_MATERIAL', app.language, translations)} onChange={(value) => onMaterialChange(value)}/>
          <InputComponent app={app} translations={translations} value={thickness} label={getUIText('GENERAL-THICKNESS', app.language, translations)} type="number" unit="mm" min={0.1} onChange={(value) => onThicknessChange(value)} />
        </Card>);

      // Content
      contentInputs = (<Card title={getUIText('CONTENT-TITLE', app.language, translations)} className="card-content" contentIc>
        <DropDownList data={mediumsList} openSetting={() => openSetting(3)} customHeader={getUIText('SETTINGS-CUSTOM_MEDIUMS', app.language, translations)} selectedItem={content} label={getUIText('CALCULATION_SELECT-CONTENT', app.language, translations)} onChange={(value) => onContentChange(value)}/>
        <InputComponent app={app} translations={translations} value={temperature} label={getUIText('CONTENT-TEMPERATURE', app.language, translations)} type="number" unit="°C" onChange={(value) => onTemperatureChange(value)} />
        {calculateEndTemperature ? <InputComponent app={app} translations={translations} value={finalTemperature} label={getUIText('CONTENT-THRESHOLD_TEMPERATURE', app.language, translations)} type="number" unit="°C" onChange={(value) => onFinalTemperatureChange(value)} /> : null}
      </Card>);

      // Sections
      if (calculateTemperatureChange) {
        sectionsContainer = (<Grid item xs={12}>
          <Paper>
            <SectionsRow />
          </Paper>
        </Grid>);
      }
    }

    // Environments
    //
    const { environments } = this.props;
    let environmentsList;
    let selectedEnvironmentItem;

    if(environments) {
      environmentsList = environments.data.map( item => {
        if(item.Nid === environmentType) {
          selectedEnvironmentItem = item.Nid;
        }
        if(item[app.language] === false) {
          return {name: item.English, id: item.Nid};
        }
        return {name: item[app.language], id: item.Nid};
      });
      environmentsList.push({
        name: getUIText('GENERAL-CUSTOM', app.language, translations),
        id: -1
      });
    }

    if(!selectedEnvironmentItem) {
      selectedEnvironmentItem = -1;
    }

    // Energy
    //
    if(calculateEnergyConsumption) {
      const { energy } = this.props;
      let energyList;
      let selectedEnergyItem;
      if(energy) {
        energyList = energy.data.map( item => {
          if(item.Nid === energyType) {
            selectedEnergyItem = item;
          }
          if(item.hasOwnProperty('custom') && item.custom) {
            return {name: item.name, id: item.Nid, custom: true};
          } else if(item[app.language] === false) {
              return {name: item.English, id: item.Nid};
          }
          return {name: item[app.language], id: item.Nid};
        });

        // TODO: registered users can only see
        if(user.username) {
          energyList.push({
            name: getUIText('CREATE_CUSTOM', app.language, translations),
            id: -3,
            custom: true
          });
        }
      }

      energyInputs = (<Grid item xs={12} sm={6} md={4} className="animated fadeIn">
            <Paper className="paper">
              <Card title={getUIText('ENERGY-TITLE', app.language, translations)} className="card-energy" iconClass="fa fa-fire">
                <Grid container spacing={2} alignContent="stretch">
                  <Grid className="grid" item xs={12} >
                    <DropDownList data={energyList} openSetting={() => openSetting(5)} selectedItem={selectedEnergyItem ? selectedEnergyItem.Nid : null} label={getUIText('ENERGY-TITLE', app.language, translations)} onChange={(value) => onEnergyTypeChange(value)} />
                    <InputComponent app={app} translations={translations} value={energyOperationTime} label={getUIText('ENERGY-OPERATING_TIME', app.language, translations)} type="number" unit="h" min={0.1} onChange={(value) => onEnergyOperationTimeChange(value)} />
                    <InputComponent app={app} translations={translations} value={energyPrice} label={getUIText('ENERGY-PRICE_OF_ENERGY', app.language, translations)} type="number" unit={getUIText('COSTS-CURRENCY', app.language, translations)} min={0.1} onChange={(value) => onEnergyPriceChange(value)} />
                  </Grid>
                </Grid>
              </Card>
            </Paper>
          </Grid>);
    }

    //
    // InsulationData alkaa tästä
    const { claddings } = this.props;
    let insulationData;
    let resultsSettings;
    let claddingsList;
    let selectedCladdingItem;
    let selectedId;
    if(claddings) {
      claddingsList = claddings.data.filter(item => {
        if(project.useMarineProducts) {
          if(item.hasOwnProperty('validToProduct') && item.validToProduct) {
            const tmpArr = item.validToProduct.split(', ');
            if(tmpArr.length && tmpArr.indexOf(insulationLayers[0].selectedItem) !== -1) {
              return true;
            }
            return false;
          } else {
            return true;
          }
        } else {
          if(item && ( (item.hasOwnProperty('validToProduct') && item.validToProduct.length < 1) || (item.hasOwnProperty('custom') && item.custom) )) {
            return true;
          }
          return false;
        }
      }).map( item => {
        if(item.hasOwnProperty('Nid') && item.Nid === cladding) {
          selectedCladdingItem = item;
        }
        if(item.hasOwnProperty('custom') && item.custom) {
          return {name: item.name, id: item.Nid, custom: true};
        } else {
          if(item[app.language] === false) {
            return {name: item.English, id: item.Nid, image: item.image};
          }
          return {name: item[app.language], id: item.Nid, image: item.image};
        }
      });

      claddingsList.push({
        name: getUIText('GENERAL-OTHER_CLADDING', app.language, translations),
        id: -1
      });

      claddingsList.unshift({
        name: getUIText('GENERAL-NO_CLADDING', app.language, translations),
        id: -2
      });

      // TODO: registered users can only see
      if(user.username) {
        claddingsList.push({
          name: getUIText('CREATE_CUSTOM', app.language, translations),
          id: -3,
          custom: true
        });
      }
      selectedId = selectedCladdingItem ? selectedCladdingItem.Nid : cladding;
    }

    const {
      sideValues
    } = sections ? sections[sectionIndex] : {};

    // Support Of Cladding for tanks
    let supportOfCladdingValue = supportOfCladding;
    let influenceOnHeatlossValue = influenceOnHeatloss;
    let spacersPerMValue = spacersPerM;

    let mechanicalFastenerValue = mechanicalFastener;
    let mechanicalInfluenceValue = mechanicalInfluence;
    let mechanicalPerMValue = mechanicalPerM;

    if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      if(selectedLayers === CALCULATION_TOP_LAYERS) {
        supportOfCladdingValue = sideValues.top.supportOfCladding;
        influenceOnHeatlossValue = sideValues.top.influenceOnHeatloss;
        spacersPerMValue = sideValues.top.spacersPerM;
        mechanicalFastenerValue = sideValues.top.mechanicalFastener;
        mechanicalInfluenceValue = sideValues.top.mechanicalInfluence;
        mechanicalPerMValue = sideValues.top.mechanicalPerM;
      } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
        supportOfCladdingValue = sideValues.side.supportOfCladding;
        influenceOnHeatlossValue = sideValues.side.influenceOnHeatloss;
        spacersPerMValue = sideValues.side.spacersPerM;
        mechanicalFastenerValue = sideValues.side.mechanicalFastener;
        mechanicalInfluenceValue = sideValues.side.mechanicalInfluence;
        mechanicalPerMValue = sideValues.side.mechanicalPerM;
      } else {
        supportOfCladdingValue = sideValues.bottom.supportOfCladding;
        influenceOnHeatlossValue = sideValues.bottom.influenceOnHeatloss;
        spacersPerMValue = sideValues.bottom.spacersPerM;
        mechanicalFastenerValue = sideValues.bottom.mechanicalFastener;
        mechanicalInfluenceValue = sideValues.bottom.mechanicalInfluence;
        mechanicalPerMValue = sideValues.bottom.mechanicalPerM;
      }
    }

    insulationData = (
      <div className="insulation-data">
        <Grid container spacing={0} alignContent="stretch" alignItems="baseline">
          <Grid item xs={12} sm={12} md={12}>
            <DropDownList data={claddingsList} openSetting={() => openSetting(4)} selectedItem={selectedId} label={getUIText('INSULATION-CLADDING', app.language, translations)} onChange={(value) => onCladdingChange(value)} specialWidth={430}/>
          </Grid>
          <Grid item xs={12} sm={2} md={12}>
            <InputComponent app={app} translations={translations} value={emissivity} label={getUIText('INSULATION-EMISSITIVITY', app.language, translations)} disabled={selectedId === -1 ? false : true} type="number" unit="ε" onChange={(value) => onEmissivityChange(value)} />
          </Grid>
          <Grid item xs={12} sm={3} md={12}>
            <a className="get-more-information" href={getMoreLink} target="_blank">{getUIText('GENERAL-LINK_TEXT', app.language, translations)}</a>
          </Grid>

          {(type === CALCULATION_TYPE_RECTANGULAR_DUCT || type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_PIPE) ?
            <Grid item xs={12} sm={4} md={12} >
              <FormControlLabel
              className="animated fadeIn"
              control={
                <Checkbox
                  checked={suspensionOfTarget}
                  onChange={(event, value) => onSuspensionChange(value)}
                />
              }
              label={getUIText('INSULATION-SUSPENSION', app.language, translations)}
              />
            </Grid> : null}

          <Grid item xs={12} sm={3} md={12}>
              {(suspensionOfTarget) ? <InputComponent app={app} translations={translations} value={suspensionInfluence} label={getUIText('INSULATION-INFLUENCE_ON_HEATLOSS', app.language, translations)} type="number" unit="%" onChange={(value) => onSuspensionHeatlossChange(value)} /> : null}
              {(suspensionOfTarget) ? <a className="pre-set" onClick={this.onSuspensionInsideClick}>{getUIText('GENERAL-INSIDE', app.language, translations)}</a> : null}
              {(suspensionOfTarget) ? <a className="pre-set" onClick={this.onSuspensionOutsideClick}>{getUIText('GENERAL-OUTSIDE', app.language, translations)}</a> : null}
          </Grid>
          <Grid item xs={12} sm={4} md={12} >
              {supportOfCladdingPossible ? <FormControlLabel
                className="animated fadeIn"
                control={
                  <Checkbox
                    checked={supportOfCladdingValue}
                    onChange={(event, value) => onSupportOfCladdingChange(value)}
                  />
                }
                label={getUIText('INSULATION-SUPPORTING', app.language, translations)}
              /> : null}
          </Grid>
          <Grid item xs={12} sm={3} md={12}>
              {/* {(supportOfCladdingValue && supportOfCladdingPossible) ? <InputComponent app={app} translations={translations} value={influenceOnHeatlossValue} label={getUIText("INSULATION-INFLUENCE_ON_HEATLOSS", app.language, translations)} type="number" unit="%" onChange={(value) => onInfluenceOnHeatlossChange(value)} /> : null} */}
              {(supportOfCladdingValue && supportOfCladdingPossible) &&
                <DropDownList
                data={spacerInputs}
                selectedItem={influenceOnHeatlossValue}
                label={getUIText('GENERAL_SPACER_TYPE', app.language, translations)}
                onChange={(value) => onInfluenceOnHeatlossChange(value)} />
              }
              {(supportOfCladdingValue && supportOfCladdingPossible && type !== CALCULATION_TYPE_CIRCULAR_DUCT && type !== CALCULATION_TYPE_PIPE ) &&
                <InputComponent app={app} translations={translations} value={spacersPerMValue} label={getUIText('GENERAL_SPACERS_PER_M2', app.language, translations)} type="number" onChange={(value) => onSpacersPerMChange(value)} />
              }

              {/* ? <InputComponent app={app} translations={translations} value={influenceOnHeatlossValue} label={'Influence on lambda value'} type="number" unit="%" onChange={(value) => onInfluenceOnHeatlossChange(value)} />
              : null} */}
              {/* (supportOfCladdingValue && supportOfCladdingPossible) ? <a className="pre-set" onClick={this.onSupportInsideClick}>{getUIText("GENERAL-INSIDE", app.language, translations)}</a> : null*/}
              {/* (supportOfCladdingValue && supportOfCladdingPossible) ? <a className="pre-set" onClick={this.onSupportOutsideClick}>{getUIText("GENERAL-OUTSIDE", app.language, translations)}</a> : null*/}
          </Grid>

          <Grid item xs={12} sm={4} md={12} >
              { ( type !== CALCULATION_TYPE_CIRCULAR_DUCT && type !== CALCULATION_TYPE_PIPE ) &&
              <FormControlLabel
                className="animated fadeIn"
                control={
                  <Checkbox
                    checked={mechanicalFastenerValue}
                    onChange={(event, value) => onMechanicalFastenerChange(value)}
                  />
                }
                label={getUIText('GENERAL_MECH_FASTENER', app.language, translations)}
              />}
          </Grid>
          <Grid item xs={12} sm={3} md={12}>
              {/* {(supportOfCladdingValue && supportOfCladdingPossible) ? <InputComponent app={app} translations={translations} value={influenceOnHeatlossValue} label={getUIText("INSULATION-INFLUENCE_ON_HEATLOSS", app.language, translations)} type="number" unit="%" onChange={(value) => onInfluenceOnHeatlossChange(value)} /> : null} */}
              {(mechanicalFastenerValue) &&
                <DropDownList
                data={mechanicalFastenersInputs}
                selectedItem={mechanicalInfluenceValue}
                label={getUIText('GENERAL_MECH_FASTENER_TYPE', app.language, translations)}
                onChange={(value) => onMechanicalInfluenceChange(value)} />
              }
              {(mechanicalFastenerValue) &&
                <InputComponent app={app} translations={translations} value={mechanicalPerMValue} label={getUIText('GENERAL_MECH_FASTENERS_PER_M2', app.language, translations)} type="number" onChange={(value) => onMechanicalPerMChange(value)} />
              }
          </Grid>
        </Grid>
      </div>
    );

    resultsSettings = ( (type === CALCULATION_TYPE_PIPE || type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) ?
      <div className="settings-button">
        <IconButton
          aria-label="More"
          aria-owns={this.state.openResultsSettings ? 'long-menu' : null}
          aria-haspopup="true"
          className="settings-icon"
          onClick={this.handleResultsSettingsClick}
        >
          <SettingsIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={this.state.anchorElResultsSettings}
          open={this.state.openResultsSettings}
          onClose={this.handleRequestResultsSettingsClose}
          style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
          MenuListProps={{
            style: {
              width: 220,
            },
          }}
        >
          <MenuItem selected={false} onClick={this.handleRequestResultsSettingsClose.bind(this, 'm')}>
            {getUIText('CALCULATION-UNIT_TYPE', app.language, translations)} W/m
          </MenuItem>
          <MenuItem selected={false}onClick={this.handleRequestResultsSettingsClose.bind(this, 'm2')}>
            {getUIText('CALCULATION-UNIT_TYPE', app.language, translations)} W/m²
          </MenuItem>
        </Menu>
      </div>
      : null);

    return (
      <div className="grid-root">
        <Grid container spacing={3} alignContent="stretch">

        {/* TYPE */}
        <Grid item xs={12} className="animated fadeIn">
          <Paper className="paper">
            <CalculationType />
          </Paper>
        </Grid>

          {/* SECTIONS */}
          { calculateTemperatureChange ? (
            <Grid item xs={12} className="animated fadeIn">
              <Paper>
                <SectionsRow onChange={(value) => onSectionIndexChange(value)} />
              </Paper>
            </Grid>
          ) : null }

          {/* CALCULATIONS */}
          <Grid item xs={12} sm={6} md={4} >
            <Paper className="paper">
                {calculationInputs}
            </Paper>
          </Grid>

          {/* DUCT TYPE */}
          {ductTypeCard}

          {/* DEFINITIONS */}
          { definitionInputs}

          {/* MATERIAL */}
          <Grid item xs={12} sm={6} md={4} >
            <Paper className="paper">
              {materialInputs}
            </Paper>
          </Grid>

          {/* MEASUREMENTS */}
          {measurementsInputs}

          {/* CONTENT */}
          <Grid item xs={12} sm={6} md={4} >
            <Paper className="paper">
              {contentInputs}
            </Paper>
          </Grid>

          {/* ENVIRONMENT */}
          <Grid item xs={12} sm={6} md={4} >
            <Paper className="paper">
              <Card title={getUIText('ENVIRONMENT-TITLE', app.language, translations)} className="card-environment" iconClass="fa fa-cloud">
                <DropDownList data={environmentsList} selectedItem={selectedEnvironmentItem} label={getUIText('ENVIRONMENT-TITLE', app.language, translations)} onChange={(value) => onEnvironmentTypeChange(value)} />
                <InputComponent app={app} translations={translations} value={environmentTemperature} label={getUIText('ENVIRONMENT-AMBIENT_TEMPERATURE', app.language, translations)} type="number" unit="°C" onChange={(value) => onEnvironmentAmbientTemperatureChange(value, -1)} />
                <InputComponent app={app} translations={translations} value={environmentAirVelocity} label={getUIText('ENVIRONMENT-AMBIENT_AIR_VELOCITY', app.language, translations)} type="number" unit="m/s" min={0} onChange={(value) => onEnvironmentAmbientAirVelocityChange(value, -1)} />
                <InputComponent app={app} translations={translations} value={environmentHumidity} label={getUIText('ENVIRONMENT-RELATIVE_HUMIDITY', app.language, translations)} type="number" unit="%" min={0} onChange={(value) => onEnvironmentHumidityChange(value, -1)} />
                { (app.country === 'Denmark' || (app.country === 'Sweden' && (type === CALCULATION_TYPE_RECTANGULAR_DUCT || type === CALCULATION_TYPE_CIRCULAR_DUCT) ) || settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1) ? <DropDownList
                    data={[
                      {name: getUIText('CALCULATION-TARGET-KLASSE', app.language, translations) + ' 1', id: 0},
                      {name: getUIText('CALCULATION-TARGET-KLASSE', app.language, translations) + ' 2', id: 1},
                      {name: getUIText('CALCULATION-TARGET-KLASSE', app.language, translations) + ' 3', id: 2},
                      {name: getUIText('CALCULATION-TARGET-KLASSE', app.language, translations) + ' 4', id: 3},
                      {name: getUIText('CALCULATION-TARGET-KLASSE', app.language, translations) + ' 5', id: 4},
                      {name: getUIText('CALCULATION-TARGET-KLASSE', app.language, translations) + ' 6', id: 5},
                    ]}
                    className="dropdownlist-klasse"
                    selectedItem={klasse}
                    label={getUIText('CALCULATION-TARGET-KLASSE-TITLE', app.language, translations)}
                    onChange={(value) => onKlasseChange(value)}
                    /> : null }
                { (app.country === 'Sweden' && type !== CALCULATION_TYPE_CIRCULAR_DUCT && type !== CALCULATION_TYPE_RECTANGULAR_DUCT) ? <DropDownList
                    data={[
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 1', id: 0},
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 2', id: 1},
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 3', id: 2},
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 4', id: 3},
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 5', id: 4},
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 6', id: 5},
                      {name: getUIText('CALCULATION-TARGET-KLASSE-PIPE-SWEDEN', app.language, translations) + ' 7', id: 6},
                    ]}
                    className="dropdownlist-klasse"
                    selectedItem={klasse}
                    label={getUIText('CALCULATION-TARGET-KLASSE-TITLE', app.language, translations)}
                    onChange={(value) => onKlasseChange(value)}
                    /> : null }
                {calculateSolarRadiation &&
                  <InputComponent app={app} translations={translations} value={environmentSolarRadiation} label={'Solar radiation'} type="number" unit="W/m2" min={0} onChange={(value) => onEnvironmentSolarRadiationChange(value, -1)} />
                }
             </Card>
            </Paper>
          </Grid>

          {/* ENERGY */}
          {energyInputs}

          {/* INSULATION */}
            <Grid item xs={12} sm={12} md={12} >
              <Paper className="paper">
                <Card title={getUIText('CALCULATION-ACCORDION_HEADER_3', app.language, translations)} className="card-insulation" insulationIc>
                  <Grid container spacing={3} alignContent="stretch" >
                    <Grid item xs={12} sm={12} md={9} >
                      {/* insulation*/}
                      <Insulation />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3}>
                      {insulationData}
                    </Grid>
                  </Grid>
                </Card>
              </Paper>
            </Grid>

        {/* Valves, fittings and flanges */
//          ( (type === CALCULATION_TYPE_RECTANGULAR_DUCT || type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_PIPE) && calculateAdapters==true)?
          ( type === CALCULATION_TYPE_PIPE && calculateAdapters === true) ?
          <Grid item xs={12} sm={12} md={12} >
            <Paper className="paper">
              <Card title={getUIText('PDF-VALVES_AND_FITTINGS', app.language, translations)} className="card-insulation" valveIc desc={getUIText('CALCULATION-VALVES_AND_FITTINGS_NOTICE', app.language, translations)}>
                <Grid container spacing={3} alignContent="stretch" >
                  <Grid item xs={12} sm={12} md={12} >
                    <ValvesFittingsComponent />
                  </Grid>
                </Grid>
              </Card>
            </Paper>
          </Grid>
          : null
        }
          {/* RESULTS */}
          <Grid id="results-container" item xs={12} sm={12} md={12} >
            <Paper className="paper">
              <Card title={getUIText('PDF-RESULTS', app.language, translations)} className="card-results" iconClass="fa fa-file-o" settingsMenu={resultsSettings}>
                <div  className="results">
                  <ResultsContainer calculation={calculations ? calculations[calculationIndex] : {}} results={results} app={app} translations={translations} sectionChange={(value) => onSectionIndexChange(value)} faceChange={(value) => onInsulationLayerPositionChange(value)} createPDF={createPDF}  />
                </div>
              </Card>
            </Paper>
          </Grid>

        </Grid>
      </div>
    );
  }
}

Calculator.propTypes = {
    project: PropTypes.object,
    claddings: PropTypes.object,
    energy: PropTypes.object,
    environments: PropTypes.object,
    materials: PropTypes.object,
    mediums: PropTypes.object,
    products: PropTypes.object,
    translations: PropTypes.object,
    settings: PropTypes.object,
    user: PropTypes.object,
    app: PropTypes.object,
    materialstandards: PropTypes.object,
  onHeatlossUnitTypeChange: PropTypes.any,
  onSuspensionHeatlossChange: PropTypes.any,
  onInfluenceOnHeatlossChange: PropTypes.any,
  adapters: PropTypes.any,
  onDirectionChange: PropTypes.any,
  onShapeChange: PropTypes.any,
  onPositionChange: PropTypes.any,
  onTankBaseChange: PropTypes.any,
  onConcreteThicknessChange: PropTypes.any,
  onThicknessChange: PropTypes.any,
  onTemperatureChange: PropTypes.any,
  onHeightChange: PropTypes.any,
  onWidthChange: PropTypes.any,
  onMaterialChange: PropTypes.any,
  onContentChange: PropTypes.any,
  onCalculateEnergyConsumptionChange: PropTypes.any,
  onCalculateTemperatureChange: PropTypes.any,
  onCalculateSolarRadiation: PropTypes.any,
  onCalculateFreezingChange: PropTypes.any,
  onCalculateEndTempretureChange: PropTypes.any,
  onValvesAndFittingsChange: PropTypes.any,
  onOuterDiameterChange: PropTypes.any,
  onLengthChange: PropTypes.any,
  onFreezingPercentageChange: PropTypes.any,
  onFinalTemperatureChange: PropTypes.any,
  onEnvironmentTypeChange: PropTypes.any,
  onEnvironmentAmbientTemperatureChange: PropTypes.any,
  onEnvironmentAmbientAirVelocityChange: PropTypes.any,
  onEnvironmentHumidityChange: PropTypes.any,
  onEnvironmentSolarRadiationChange: PropTypes.any,
  onEnergyTypeChange: PropTypes.any,
  onEnergyOperationTimeChange: PropTypes.any,
  onEnergyPriceChange: PropTypes.any,
  onCladdingChange: PropTypes.any,
  onEmissivityChange: PropTypes.any,
  onSupportOfCladdingChange: PropTypes.any,
  onSpacersPerMChange: PropTypes.any,
  onMechanicalFastenerChange: PropTypes.any,
  onMechanicalInfluenceChange: PropTypes.any,
  onMechanicalPerMChange: PropTypes.any,
  onSuspensionChange: PropTypes.any,
  onInsulationLayerChange: PropTypes.any,
  onInsulationLayerPositionChange: PropTypes.any,
  onSectionIndexChange: PropTypes.any,
  onFlowRateChange: PropTypes.any,
  onFlowRateTypeChange: PropTypes.any,
  onNoInsulationChange: PropTypes.any,
  onDuctTypeChange: PropTypes.any,
  createPDF: PropTypes.any,
  openSetting: PropTypes.any,
  onMaterialStandardChange: PropTypes.any,
  onKlasseChange: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        project: state.project,
        claddings: state.claddings,
        energy: state.energy,
        environments: state.environments,
        materials: state.materials,
        mediums: state.mediums,
        products: state.products,
        translations: state.translations,
        adapters: state.adapters,
        settings: state.settings,
        user: state.user,
        app: state.app,
        materialstandards: state.materialstandards,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onHeightChange: height => dispatch(patchCalculationSection({ height, materialStandard: '-1' })),
        onWidthChange: width => dispatch(patchCalculationSection({ width, materialStandard: '-1' })),
        onThicknessChange: thickness => dispatch(patchCalculationSection({ thickness, materialStandard: '-1' })),
        onTemperatureChange: temperature => dispatch(patchCalculationSection({ temperature })),
        onMaterialChange: material => dispatch(patchCalculationSection({ material, materialStandard: '-1' })),
        onContentChange: content => dispatch(patchCalculationSection({ content })),

        onDirectionChange: direction => dispatch(patchCalculationSection({ direction })),
        onShapeChange: shape => dispatch(patchCalculationSection({ shape })),
        onPositionChange: position => dispatch(patchCalculationSection({ position })),
        onTankBaseChange: tankBase => dispatch(patchCalculationSection({ tankBase })),
        onConcreteThicknessChange: concreteThickness => dispatch(patchCalculationSection({ concreteThickness })),

        onCalculateTemperatureChange: calculateTemperatureChange => dispatch(patchCalculation({ calculateTemperatureChange })),
        onCalculateEnergyConsumptionChange: calculateEnergyConsumption => dispatch(patchCalculation({ calculateEnergyConsumption })),
        onCalculateSolarRadiation: calculateSolarRadiation => dispatch(patchCalculation({ calculateSolarRadiation })),
        onCalculateFreezingChange: calculateFreezing => dispatch(patchCalculationSection({ calculateFreezing })),
        onCalculateEndTempretureChange: calculateEndTemperature => dispatch(patchCalculation({ calculateEndTemperature })),
        onValvesAndFittingsChange: calculateAdapters => dispatch(patchCalculationSection({ calculateAdapters })),

        onEnvironmentTypeChange: environmentType => dispatch(patchCalculationSection({ environmentType })),
        onEnvironmentAmbientTemperatureChange: (environmentTemperature, environmentType) => dispatch(patchCalculationSection({ environmentTemperature, environmentType })),
        onEnvironmentAmbientAirVelocityChange: (environmentAirVelocity, environmentType) => dispatch(patchCalculationSection({ environmentAirVelocity, environmentType })),
        onEnvironmentHumidityChange: (environmentHumidity, environmentType) => dispatch(patchCalculationSection({ environmentHumidity, environmentType })),
        onEnvironmentSolarRadiationChange: environmentSolarRadiation => dispatch(patchCalculationSection({ environmentSolarRadiation })),

        onEnergyTypeChange: energyType => dispatch(patchCalculation({ energyType })),
        onEnergyOperationTimeChange: energyOperationTime => dispatch(patchCalculation({ energyOperationTime })),
        onEnergyPriceChange: energyPrice => dispatch(patchCalculation({ energyPrice })),

        onOuterDiameterChange: outerDiameter => dispatch(patchCalculationSection({ outerDiameter, materialStandard: '-1' })),
        onLengthChange: length => dispatch(patchCalculationSection({ length })),
        onFreezingPercentageChange: freezingPercentage => dispatch(patchCalculationSection({ freezingPercentage })),
        onFinalTemperatureChange: finalTemperature => dispatch(patchCalculationSection({ finalTemperature })),

        onCladdingChange: cladding => dispatch(patchCalculationSection({ cladding })),
        onEmissivityChange: emissivity => dispatch(patchCalculationSection({ emissivity })),
        onSupportOfCladdingChange: supportOfCladding => dispatch(patchCalculationSection({ supportOfCladding })),
        onInfluenceOnHeatlossChange: influenceOnHeatloss => dispatch(patchCalculationSection({ influenceOnHeatloss })),
        onSpacersPerMChange: spacersPerM => dispatch(patchCalculationSection({ spacersPerM })),

        onMechanicalFastenerChange: mechanicalFastener => dispatch(patchCalculationSection({ mechanicalFastener })),
        onMechanicalInfluenceChange: mechanicalInfluence => dispatch(patchCalculationSection({ mechanicalInfluence })),
        onMechanicalPerMChange: mechanicalPerM => dispatch(patchCalculationSection({ mechanicalPerM })),

        onSuspensionChange: suspensionOfTarget => dispatch(patchCalculationSection({ suspensionOfTarget })),
        onSuspensionHeatlossChange: suspensionInfluence => dispatch(patchCalculationSection({ suspensionInfluence })),

        onHeatlossUnitTypeChange: heatlossUnitType => dispatch(patchCalculationSection({ heatlossUnitType })),

        onInsulationLayerChange: insulationLayers => dispatch(patchCalculationSection({ insulationLayers })),
        onSectionIndexChange: sectionIndex => dispatch(patchCalculation({ sectionIndex })),
        onInsulationLayerPositionChange: selectedLayers => dispatch(patchCalculationSection({ selectedLayers })),

        onFlowRateChange: flowRate => dispatch(patchCalculationSection({ flowRate })),
        onFlowRateTypeChange: flowRateType => dispatch(patchCalculation({ flowRateType })),

        // onDuctTypeChange: type => dispatch(changeType({ type })),
        onDuctTypeChange: type => dispatch(patchCalculationSection({ type })),
        onMaterialStandardChange: materialStandard => dispatch(patchCalculationSection({ materialStandard })),
        createPDF: () => dispatch(pdfCreateRequest()),

        openSetting: layout => dispatch(openSetting(layout)),
        onKlasseChange: klasse => dispatch(patchCalculationSection({klasse})),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Calculator);
